import React from 'react';
import { connect } from 'react-redux';

import {
  Button,
  BackgroundImage,
  Typography,
  Color,
  FontType,
  Box,
  Size
} from '@americanexpress/aqx-components';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';

import { getG166 } from './redux';

import styles from './styles.scss?modules';

const TestimonialCards = ({
  G166: {
    active,
    variants: { isControl, isBlue },
    data: { header, footer, cards, dtm }
  },
  g166Color
}) => {
  const backgroundColor = isBlue ? Color.BrightBlue : Color.Gray01;
  const fontColor = isBlue ? Color.White : Color.DeepBlue;
  const buttonType = isBlue ? 'secondary' : 'primary';

  return (
    active &&
    !isControl && (
      <>
        <LazyScrollMetricTracker
          scrollDtm={{
            ...dtm,
            eventAsset: replaceStringWithVars({
              varsObject: { color: g166Color },
              string: dtm.eventAsset || ''
            })
          }}
        />
        <div className={styles.testimonialSection}>
          <Typography
            className={styles.header}
            $family={FontType.BentonRegular}
            $size={30}
            theme={{
              color: Color.Black
            }}
          >
            {header}
          </Typography>
          <div className={styles.cardsSection}>
            {cards.map((card, idx) => {
              return (
                <Box
                  key={`testimonial-card-${idx}`}
                  className={styles.card}
                  $border={true}
                  theme={{
                    bgColor: backgroundColor,
                    rounded: Size.SM
                  }}
                >
                  <BackgroundImage height={159} imageUrl={card.asset} />
                  <div className={styles.container}>
                    <Typography
                      className={styles.quote}
                      $family={FontType.BentonRegular}
                      $size={20}
                      theme={{
                        color: fontColor
                      }}
                    >
                      {card.quote}
                    </Typography>

                    <Typography
                      className={styles.attribution}
                      $family={FontType.HelveticaRegular}
                      $size={16}
                      theme={{
                        color: fontColor
                      }}
                    >
                      {card.attribution}
                    </Typography>

                    <Button
                      $isMinMax={true}
                      $type={buttonType}
                      href={card?.button?.link}
                      onClick={() => {
                        sendDTMClickEvent({
                          ...card.dtm,
                          eventAsset: replaceStringWithVars({
                            varsObject: { color: g166Color },
                            string: card.dtm.eventAsset
                          })
                        });
                        window.open(card.button.link, '_blank');
                      }}
                    >
                      {card?.button?.text}
                    </Button>
                  </div>
                </Box>
              );
            })}
          </div>
          <Typography
            className={styles.footer}
            $family={FontType.HelveticaRegular}
            $size={13}
            theme={{
              color: Color.Black
            }}
          >
            {footer}
          </Typography>
        </div>
      </>
    )
  );
};

const mapStateToProps = state => {
  return {
    G166: getG166(state),
    g166Color: getG166(state).data.color
  };
};

export default connect(mapStateToProps)(TestimonialCards);
